import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AttendanceTypeListComponent } from './attendance-type-list/attendance-type-list.component';
import { AttendanceTypeFormComponent } from './attendance-type-form/attendance-type-form.component';


@NgModule({
  declarations: [
    AttendanceTypeListComponent,
    AttendanceTypeFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
  ]
})
export class AttendanceTypeModule { }
